export default __webpack_public_path__ + "static/lutein-zeaforce-slider-lifestyle-mobile-9bc7d6face4e32680979e376c8ac39d3.jpg";